import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const UndoIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M9.7 4.7a1 1 0 0 0-1.4-1.4l-5 5a1 1 0 0 0 0 1.4l5 5a1 1 0 0 0 1.4-1.4L6.4 10h8.1a4.5 4.5 0 0 1 0 9H11a1 1 0 1 0 0 2h3.5a6.5 6.5 0 1 0 0-13h-8l3.2-3.3Z" />
  </Icon>
));
export default UndoIcon;
